import React from 'react';
import * as echarts from 'echarts/lib/echarts';
import echartsColorTheme from '../echartsColorTheme';

import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/boxplot';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/transform';

const anthrax_monthly_data = [[3, 3, 1, 3, 7, 1, 1, 8, 7, 6, 6, 1, 7, 2, 2], [1, 2, 0, 0, 1, 1, 3, 5, 3, 4, 5, 4, 2, 5, 3], [4, 2, 0, 2, 5, 2, 2, 2, 3, 3, 1, 7, 2, 4, 3], [2, 3, 3, 2, 4, 1, 4, 8, 5, 5, 7, 3, 6, 5, 2], [3, 2, 5, 8, 4, 1, 5, 5, 6, 5, 5, 11, 8, 0, 4], [4, 4, 4, 9, 4, 3, 2, 7, 6, 2, 5, 4, 4, 8, 2], [12, 7, 10, 5, 7, 10, 6, 3, 14, 11, 15, 8, 22, 5, 5], [5, 13, 9, 6, 14, 6, 17, 4, 10, 21, 20, 17, 27, 11, 7], [4, 5, 5, 12, 5, 1, 9, 4, 7, 10, 10, 17, 14, 9, 3], [4, 5, 8, 3, 2, 2, 4, 7, 15, 6, 8, 10, 8, 7, 4], [5, 6, 5, 2, 4, 1, 9, 8, 10, 11, 5, 8, 7, 3, 1], [3, 2, 6, 4, 4, 3, 6, 3, 4, 8, 9, 6, 5, 2, 0]]
const month_name = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

class MonthlyBoxplot extends React.Component {
  constructor(props) {
    super(props);
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = null;
    this.state = {
      startYear: 2005,
      endYear: 2019,
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    if (parseInt(this.state.startYear) > parseInt(this.state.endYear)) {
      alert(`Invalid year range from ${this.state.startYear} to ${this.state.endYear}.`);
      return;
    } else {
      // update chart
      this.myChart.setOption({
        dataset: [{
          source: anthrax_monthly_data.map(yearData => yearData.slice(this.state.startYear - 2005, this.state.endYear - 2004))
        }, {
          transform: {
            type: 'boxplot',
          }
        }, {
          fromDatasetIndex: 1,
          fromTransformResult: 1
        }]
      });
    }
  }

  handleInputChange(event) {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  }

  componentDidMount() {
    echarts.registerTheme('customColorTheme', echartsColorTheme);
    this.myChart = echarts.init(document.getElementById('monthly-boxplot'), 'customColorTheme', 'EN');
    var option = {
      grid: {
        left: 'center',
        width: '85%',
        top: '10%'
      },
      animation: true,
      tooltip: {
        formatter: (params) => {
          if (params.value.length === 6) {
            return `${params.seriesName}<br/>${params.marker} ${month_name[params.value[0]]}&emsp;<b>${params.value[3]}</b>`
          } else {
            return `${params.seriesName}<br/>${params.marker} ${month_name[params.value[0]]}&emsp;<b>${params.value[1]}</b>`
          }
        }
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      legend: {
        left: 'center',
        top: '0px',
      },
      dataset: [{
        source: anthrax_monthly_data
      }, {
        transform: {
          type: 'boxplot',
        }
      }, {
        fromDatasetIndex: 1,
        fromTransformResult: 1
      }],
      xAxis: {
        type: 'category',
        boundaryGap: true,
        nameGap: 30,
        splitArea: {
          show: false
        },
        splitLine: {
          show: false
        },
        axisLabel: {
          formatter: function (value) {
            return month_name[value];
          }
        }
      },
      yAxis: {
        type: 'value',
        splitArea: {
          show: true
        }
      },
      series: [{
        type: 'boxplot',
        name: 'boxplot',
        datasetIndex: 1,
      }, {
        name: 'outlier',
        type: 'scatter',
        datasetIndex: 2
      }]
    };
    this.myChart.setOption(option);
  }
  render() {
    var yearRange = Array.from({ length: 15 }, (_, i) => i + 2005);
    var startYearOptions = yearRange.map((x) => {
      if (x === this.state.startYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    var endYearOptions = yearRange.map((x) => {
      if (x === this.state.endYear) {
        return (<option selected value={x}>{x}</option>)
      } else {
        return (<option value={x}>{x}</option>)
      }
    });
    return (
      <>
        <form class="form-inline justify-content-center" style={{ 'margin-bottom': '30px' }}>
          <div class="form-group" style={{ 'padding-right': '25px' }}>
            <label style={{ 'padding-right': '10px' }}>Start Year</label>
            <select class="form-control" name="startYear" onChange={this.handleInputChange}>
              {startYearOptions}
            </select>
          </div>
          <div class="form-group" style={{ 'padding-right': '25px' }}>
            <label style={{ 'padding-right': '10px' }}>End Year</label>
            <select class="form-control" name="endYear" onChange={this.handleInputChange}>
              {endYearOptions}
            </select>
          </div>
          <button type="button" class="btn btn-outline-secondary" onClick={this.handleSubmit}>Submit</button>
        </form>
        <div class="m-auto" id="monthly-boxplot" style={{ height: '400px' }}></div>
      </>
    );
  }
}

export default MonthlyBoxplot;